import {createStandardActions, GetActions, placeholder, readonly, standardItemsReducer} from "../../utils";
import {createStandardSelectors, getEntities, selector} from "../../selectors";
import {combineReducers} from "redux";
import {archiveProgram, restoreProgram, upsertProgram} from "../../../api/inventory/inventoryApi";
import {CommonDispatch} from "../../index";

export interface Program {
  id: string;
  name: string;
  archivedAt: string | null;
}

const actions = createStandardActions(placeholder<Program>(), 'PROGRAM/SET', 'PROGRAM/SAVE');
const selectors = createStandardSelectors(placeholder<Program>(), s => getEntities(s).programs);
export type ProgramActions = GetActions<typeof actions>;
export const programs = combineReducers({items: standardItemsReducer<Program, ProgramActions>(actions)});
export const programStore = readonly({
  selectors: {
    ...selectors,
    unarchived: selector(s => selectors.getAsArray(s).filter(p => p.archivedAt === null)),
    archived: selector(s => selectors.getAsArray(s).filter(p => p.archivedAt !== null)),
  },
  actions: {
    ...actions,
    upsert: (req: {id: string, name: string, archivedAt?: string | null}) => async (dispatch: CommonDispatch) => {
      const response = await upsertProgram(req);
      dispatch(programStore.actions.save(response));
    },
    archive: (id: string) => async (dispatch: CommonDispatch) => {
      const response = await archiveProgram(id);
      dispatch(programStore.actions.save(response));
    },
    restore: (id: string) => async (dispatch: CommonDispatch) => {
      const response = await restoreProgram(id);
      dispatch(programStore.actions.save(response));
    }
  }
});
